import { NotEligible } from '../../../public/NotEligible';

const sorryMessage = `Tut uns leid. Die Auswertung  hat ergeben, 
  dass Du leider nicht zur Teilnahme an der Studie berechtigt bist.`;

export const Deactivated = () => {
  return <NotEligible customSorry={sorryMessage} canLogout />;
};
